import { createSelector } from '@reduxjs/toolkit';

import { naturalSortByProperty } from '@paragon/utilities';

import { RootState } from '../store';

export const getTruckDriverOptions = createSelector(
  (state: RootState) => state.truckDrivers,

  (truckDrivers) =>
    naturalSortByProperty(
      Object.values(truckDrivers).filter((truckDriver) => !truckDriver.archived),
      (truckDriver) => truckDriver.name,
    ),
);
